import { render, staticRenderFns } from "./DanhSachThongBao.vue?vue&type=template&id=d9b3bc14&scoped=true&"
import script from "./DanhSachThongBao.vue?vue&type=script&lang=js&"
export * from "./DanhSachThongBao.vue?vue&type=script&lang=js&"
import style0 from "./DanhSachThongBao.vue?vue&type=style&index=0&id=d9b3bc14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b3bc14",
  null
  
)

export default component.exports